import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatepickerComponent } from './datepicker.component';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [DatepickerComponent],
	imports: [CommonModule, OwlDateTimeModule, OwlMomentDateTimeModule, FormsModule],
	exports: [DatepickerComponent]
})
export class WmDatepickerModule {}
